<mat-dialog-content style="display: flex; flex-direction: column;">

    <h2 mat-dialog-title style="margin: 0px;">Kunden Account kopieren</h2>


    <div style="margin-bottom: 20px;">
        <div>
            Zielkunde
        </div>
        <button mat-button (click)="selectToKunde()" *ngIf="!toAccountId">Zielkunde auswählen</button>
        <ng-container *ngIf="toAccountId">
            {{toAccountName}}&nbsp;<mat-icon style="cursor: pointer;" (click)="clearToKunde()">close</mat-icon>
        </ng-container>
    </div>

    <div>
        <div>
            Quellkunde
        </div>
        <button mat-button (click)="selectFromKunde()" *ngIf="!fromAccountId">Quellkunde auswählen</button>
        <ng-container *ngIf="fromAccountId">
            {{fromAccountName}}&nbsp;<mat-icon style="cursor: pointer;" (click)="clearFromKunde()">close</mat-icon>
        </ng-container>
    </div>


    <mat-dialog-actions>
        <button mat-button color="warn" mat-dialog-close tabindex="-1">Abbrechen</button>
        <button mat-button color="accent" (click)="copyAccountData()"
            [disabled]="!toAccountId || !fromAccountId">Account kopieren</button>
    </mat-dialog-actions>